<template>
    <div class="global-hotWord ">
        <bannerSearch :isShowAi='false' :isNewPage="false" @banner_search="banner_search" ref="bannerSearch"></bannerSearch>
        <div class="page-cont" >
            <div class="hotWord-menu"> 
                <div class="menu-tit">知识分类目录</div>
                <el-tree v-loading="treeLoad" ref="treeRef" show-checkbox class="menu-tree" :data="treeList" :props="defaultProps" 
                    node-key="label"
                    @check-change="handleCheckChange"
                    @node-click="handleNodeClick">
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <el-tooltip :content="node.label" placement="top" :disabled="node.label.length < 11">
                            <span class="tree-label">{{ node.label }}</span>
                        </el-tooltip>
                        <span class="tree-num">[{{ data.count?data.count:0 }}]</span>
                    </div>
                </el-tree>

            </div>
            <div class="hotWord-cont"> 
                <div class="search-result">
                    <el-input class="result-input" size="small" placeholder="请输入查询内容" clearable v-model.trim="resultSearch"  />
                    <div class="result-btn">
                        <el-button type="primary" size="small" plain @click="getList(1)">结果中检索</el-button> 
                        <el-button type="danger" size="small"  plain @click="resultSearch_clear">清空</el-button> 
                    </div>
                </div>
                <div v-loading="listLoad">
                    <div class="result-num">已找到 {{ pageInfo.total }} 条结果</div>
                    <p class="no-data" v-if="pageInfo.total==0">暂无数据～</p>
                    <ul v-else class="cont-list">
                        <li class="list-info" v-for="(item,index) in listInfo" :key="index">
                            <div class="info-tit">
                                <a href="javascript:;" v-html="item.row" @click="jump_prompt(item)"></a>
                            </div>
                            <div class="info-txt" v-for="(list,num) in item.subtitleList" :key="num">
                                <b>[{{ list.label }}]：</b>
                                <p v-html="list.text"></p>
                            </div> 
                        </li>
                    </ul>
                    <el-pagination  
                        class="page-wrap"  
                        @current-change="changePage" 
                        @size-change="sizeChange"
                        background
                        :current-page="pageInfo.pageNum" 
                        :page-count="pageInfo.pageTotal" 
                        :page-size="pageInfo.pageSize"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :total="pageInfo.total"
                        layout="total, sizes, prev, pager, next, jumper" >
                    </el-pagination>
                </div>
            </div>
         </div>
         <!-- <modelTip :ok="'确定'" :cancel="'取消'"  :show.sync='isShowTip' @ok='sureTip' :width="'450px'" :title="'提示'">
            <div slot="content" >
                <p v-html="scoreMsg"></p>
            </div>
        </modelTip> -->
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip"></deductScore>
    </div>
</template>

<script> 
import modelTip from '../components/ui-kit/model_tip.vue'
import bannerSearch from './comps/banner_search.vue'
import deductScore from './comps/deduct_score.vue'
import {commonSearch,globalSearchTree} from '../io/api.js'
export default {
    components:{
        bannerSearch,
        modelTip,
        deductScore
    },
    data () {
        return {
            searchWord:this.$route.query.word||'',
            menuIndex:0, 
            listLoad:false,
            treeLoad:false,
            treeList:[],
            defaultProps: {
                children: 'children',
                label: 'label'
            } ,
            resultSearch:'', 
            selectedNodes: [], // 存储选中的节点
            selectedNodesTableVal:'',
            listInfo:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            isShowTip:false,
            scoreMsg:'',
            scoreType:'',//扣除个人还是机构
            scoreItem:{},//扣除积分的item

        }
    },
    mounted () {
        this.getList();
        this.getTree();
    },
    watch:{
        selectedNodesTableVal(val,old){
           if(val){
                this.getList(1)
           }
        }
    },
    methods: {
        //banner检索
        banner_search(val){ 
            this.searchWord=val;
            this.getList(1);
            this.getTree();
        },
        //页面检索
        getList(num){
            if(!this.searchWord){
                this.$message.warning('检索词不能为空～')
                return
            }
            this.listLoad=true;
            this.pageInfo.pageNum=num?num:this.pageInfo.pageNum
            let params={
                link: "",
                table: this.selectedNodesTableVal,
                searchWord:this.searchWord,
                secondSearchWord:this.resultSearch,
                page: this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,

            } 
            commonSearch(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.listInfo=data.list||[];
                    this.pageInfo.total=data.totalCount;
                }else{
                    this.$message.error('检索失败～')
                }
                this.listLoad=false;
            })
        },
        //左侧目录
        getTree(){
            this.treeLoad=true;
            let params={
                link: "",
                table: "",
                keywords:this.searchWord, 

            } 
            globalSearchTree(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.treeList=data.treeStructure||[];
                }else{
                    this.$message.error('请求失败～')
                }
                 this.treeLoad=false;
            })
        },
        //二级检索清空
        resultSearch_clear(){
            this.resultSearch='';
            this.searchWord='';
            this.$refs.bannerSearch.clear_search();
        },
        jump_prompt(item){
            this.isShowTip=true; 
            this.$nextTick(()=>{
                let searchWord=this.searchWord?this.searchWord:''; 
                this.$refs.deduct_score.get_checkScoreStatus(item,searchWord)
            })
        },
        //查询扣除积分
        // get_checkScoreStatus(item){
        //     this.scoreMsg='';
        //     this.scoreItem=item;
        //     let params={
        //         id: this.scoreItem.Tid,
        //         link:this.scoreItem.link,
        //         table: this.scoreItem.table,
        //         searchWord:this.searchWord?this.searchWord:this.$route.query.word||'',
        //     }
        //     isDeductScore(params).then(res=>{
        //         let {code,msg,data} =res.data;
        //         if(code==0){
        //             this.scoreMsg='';
        //             this.scoreType=data.type;
        //             if(this.scoreType=='already'){
        //                 this.toPill(this.scoreItem)
        //                 return
        //             }else if(this.scoreType=='zero_score'){ 
        //                 this.scoreMsg='积分不足请联系管理员' 
        //             }else if(this.scoreType=='institutional_personal_expire'){ 
        //                 this.scoreMsg='机构积分和个人积分已过期' 
        //             }else if(this.scoreType=='personal_expire'){
        //                 this.scoreMsg='个人积分已过期'  
        //             }else if(this.scoreType=='institution'){
        //                 this.scoreMsg=`扣除机构<b> ${data.score}</b> 积分`; 
        //             }else if(this.scoreType=='person'){
        //                 this.scoreMsg=`扣除个人<b> ${data.score}</b> 积分`; 
        //             }
                    
        //             this.isShowTip=true; 
        //         }else{
        //             this.$message.error(msg||'请求失败～')
        //         }
        //     })
        // },
        // //确定扣除积分
        // sureTip(item){
        //     if(this.scoreType=='zero_score'||this.scoreType=='institutional_personal_expire'||this.scoreType=='personal_expire'){ 
        //         this.isShowTip=false;
        //         return
        //     }
        //     let params={
        //         id: this.scoreItem.Tid,
        //         link:this.scoreItem.link,
        //         table: this.scoreItem.table,
        //         searchWord:this.searchWord?this.searchWord:this.$route.query.word||'',
        //     }
        //     checkScoreStatus(params).then(res=>{
        //         let {code,msg,data} =res.data;
        //         if(code==0){   
        //             if(data.type=='institution'){ 
        //                 this.$store.state.institutionalScore=this.$store.state.institutionalScore-data.score;
        //             }else if(data.type=='person'){
        //                 this.$store.state.personalScore=this.$store.state.personalScore-data.score;
        //             }
        //             this.toPill(this.scoreItem)
                    
        //         }else{
        //             this.$message.error(msg||'请求失败～')
        //         } 
        //         this.isShowTip=false;
        //     })
        // },
        // toPill(item){
        //     let query={
        //         word:this.searchWord?this.searchWord:this.$route.query.word||'',
        //     };
        //     let url= this.$router.resolve({
        //         path:'pill',
        //         query,
        //     }) 
        //     //放到query里太长了，所以用localStorage传值，pill页面接口是使用
        //     window.localStorage.setItem('globalRow',JSON.stringify(item))
        //     this.$windowOpen({ url:url.href,isLogin:true} )
        // },
        //确定扣除积分
        // sureTip(){
            // if(this.scoreType=='institution'){ 
            //     this.$store.state.institutionalScore=this.$store.state.institutionalScore-data.score;
            // }else if(data.type=='person'){ 
            //     this.$store.state.personalScore=this.$store.state.personalScore-data.score;
            // }
            // this.toPill(this.scoreItem)
        // },
        handleNodeClick(data, node) {  
        },
        handleCheckChange(data, checked, indeterminate) {
            const node = this.$refs.treeRef.getNode(data);
            if (!node) return;

            // 实时获取所有选中的三级目录节点
            const checkedNodes = this.$refs.treeRef.getCheckedNodes(true);
            this.selectedNodes = checkedNodes;
            this.selectedNodesTableVal='';
            let tableValArr=[];
            checkedNodes&&checkedNodes.forEach(item=>{
                tableValArr.push(item.tableValue) 
            })
            this.selectedNodesTableVal=tableValArr.join(','); 
            // this.getList();
        },
        changePage(num) {
            this.pageInfo.pageNum = num; 
            this.getList()
        },
        sizeChange(val) {
             this.pageInfo.pageSize=val;
             this.getList()
        },
    }
}
</script>
<style lang="less" scoped>
.global-hotWord{ 
    .page-cont{
        display: flex;
        justify-content: space-between;
        min-height: 300px;
    }
    .hotWord-menu{
        width: 260px; 
        height: auto;
        .menu-tit{ 
            line-height: 20px;
            padding:10px;
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            background: #386DE8;
        }
        .menu-tree{
            border:1px solid #386DE8;
            ::v-deep .el-tree-node__content{
                height:40px;
            }
            .custom-tree-node{
                color: #000; 
                width: 100%;
                min-width: 176px;
                max-width: 214px;
                display: flex;
                font-size: 14px;
                line-height: 40px;
                justify-content: space-between;
                padding-right: 10px;
                .tree-label {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 150px;
                }
                .tree-num{
                    color: #909399;
                }
            } 
        }
        .list{
            font-size: 14px; 
            height: 40px;
            line-height: 40px;
            a{
                color: #333;
                font-weight: normal; 
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis; 
                padding:0 10px;
                background: #F1F5FE;
                &:hover,&.active{ 
                    font-weight: bold;
                    color: #fff;
                    background: #386DE8;
                }
            }
        }
    }
    .hotWord-cont{
        width: 920px; 
        .result-num{ 
            font-weight: bold;
        }
        .no-data{
            padding:40px 0;
            font-size: 18px;
            font-weight: bold;
            text-align: center;
        }
        .search-box,.search-result{
            display: flex;
            margin-bottom: 20px;
        }
         .search-box{
            justify-content: space-between;
            .search-input{
                width: 780px;
            }
            
        }
        .search-result{
            .result-input{
                width: 300px;
                margin-right: 20px;
            }
        }
        
        .list-info{ 
            padding:14px 10px 10px;
            &:nth-child(even) {
                background-color: #F1F5FE;
            }
            .info-tit{
                font-size: 20px;
                line-height: 20px;
                margin-bottom: 8px;
                a{
                    display: inline;
                    color: #386DE8;
                    &:hover{
                        color: #333;
                    }
                }
            }
            .info-txt{
                line-height: 30px;
                display: flex;
            }
        }
    }
}
</style>
